import Aden from '@/service';
export function ChainList(id: number) {
  return Aden.get({
    url: `/api/bar/chain/account/info/${id}`,
  });
}

// 获取连锁商户分页列表
export function getChainList(data: any) {
  return Aden.get({
    url: '/api/bar/chain/link/pageList',
    params: data,
  });
}
// 提出连锁商户
export function quitChain(data: any) {
  return Aden.post({
    url: '/api/bar/chain/link/kick/out',
    data: data,
  });
}
